export var ServerRequestStatusType;
(function (ServerRequestStatusType) {
    ServerRequestStatusType["Sent"] = "Sent";
    ServerRequestStatusType["NoAction"] = "NoAction";
    ServerRequestStatusType["OK"] = "OK";
    ServerRequestStatusType["Error"] = "Error";
})(ServerRequestStatusType || (ServerRequestStatusType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/serverRequestStatusType.ts
// module id = 49
// module chunks = 50